export const getPlatformLink = () => {
  const userAgent = navigator.userAgent || navigator.vendor || '';

  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

  const aosUrl = 'https://play.google.com/store/apps/details?id=com.thehumanplus.shuffle';
  const iosUrl =
    'https://apps.apple.com/kr/app/shuffle-%EC%85%94%ED%94%8C-%EB%82%98%EB%A7%8C%EC%9D%98-%EC%9E%90%EC%9C%A0%EB%A1%9C%EC%9A%B4-%EB%94%94%EC%A7%80%ED%84%B8-%EC%A7%80%EA%B0%91/id1509428401';
  if (isAndroid) {
    return aosUrl;
  }
  if (isIOS) {
    return iosUrl;
  }
  return aosUrl;
};

export const getAssetPlatformLink = () => {
  return 'https://hupayx.ecpay.io/';
};

export const getNaviMineLink = () => {
  return 'https://assetfirwa.ecpay.io/';
};
